import React, { useCallback, useEffect, useRef, useState } from 'react';
import Slider from 'rc-slider';

import {
  rangeMinStep,
  maxRangeValue,
  minRangeValue,
  rangeDefaultValue,
  GAME_FULL_RANGE_RULER_COUNT,
} from '../../../helpers/constants';

import 'rc-slider/assets/index.css';

const RangeSection = ({ marketType, rangeNumber, setRangeNumber }) => {
  const [isTouchEnd, setIsTouchEnd] = useState(false);
  const rangeRef = useRef();

  const sliderTrack = document.getElementsByClassName('rc-slider-handle')[0];

  useEffect(() => {
    if (sliderTrack) {
      sliderTrack.setAttribute('data-ruler-num', `${rangeNumber}`);
    }
  }, [rangeNumber, sliderTrack]);

  const handleRangeChange = useCallback(
    (value) => {
      if (!isTouchEnd) {
        setRangeNumber(value);
      }
    },
    [setRangeNumber, isTouchEnd]
  );

  useEffect(() => {
    rangeRef.current.sliderRef.addEventListener('touchstart', () => setIsTouchEnd(false));
    rangeRef.current.sliderRef.addEventListener('touchend', () => setIsTouchEnd(true));
  }, [rangeNumber, marketType]);

  return (
    <div className='monti-input-range-wrp-holder'>
      <div className='monti-input-range-wrp'>
        <div className='monti-input-range-holder'>
          <div className='monti-ruler-wrp'>
            <div className='monti-ruler-holder'>
              {GAME_FULL_RANGE_RULER_COUNT.map((item) => (
                <div className='monti-ruler-item' data-ruler-percent='' key={item} />
              ))}
            </div>
          </div>
        </div>
        <Slider
          ref={rangeRef}
          value={rangeNumber}
          min={minRangeValue}
          max={maxRangeValue}
          step={rangeMinStep}
          defaultValue={rangeDefaultValue}
          onChange={handleRangeChange}
          railStyle={{ backgroundColor: '#3B5697' }}
          startPoint={marketType ? maxRangeValue : minRangeValue}
          trackStyle={{ backgroundColor: marketType ? '#6FD6FE' : '#8F93FF', height: 5 }}
          // style={{ opacity: isBetsClosed ? 0.5 : 1, pointerEvents: isBetsClosed ? 'none' : '' }}
          handleStyle={{
            backgroundColor: marketType ? '#6FD6FE' : '#8F93FF',
            borderColor: marketType ? '#47B6E2' : '#A6A7FB',
          }}
        />
      </div>
    </div>
  );
};

export default RangeSection;
